import React from "react";

const Header = (props) => {
  return <div className="flex items-center justify-end w-full"></div>;
};

export default Header;
